import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useContentItemVisibilityPost = () => {
  const createContentItemVisibilityRequest = useCallback((payloadData) => {
    const url = `${API_BASE_URL}/api/v3/visibility/content-item-visibility/`;
    const payload = payloadData;
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createContentItemVisibilityRequest);
};

export default useContentItemVisibilityPost;
